import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import Quote from 'models/quote';
import Venue from 'models/venue';

const propTypes = {
  quote: PropTypes.instanceOf(Quote),
  venue: PropTypes.instanceOf(Venue),
};

const defaultProps = {
  venue: null,
  quote: new Quote(),
};

const TierAmenities = ({ quote, venue }) => {
  if (!venue || !venue.enhancedAirport) { return null; }

  const panelClasses = cx({
    'checkout-section': true,
    'clearfix': true,
    'tier-amenities-panel': true,
    'border-color-grey': true,
    'border-side-top': true,
    'border-style-solid': true,
    'padding-top-30': true,
    'padding-bottom-40': true,
  });

  return (
    <div className={panelClasses}>
      <h2 className="display-sm-inline-block display-xs-block margin-bottom-sm-15 margin-top-xs-0 margin-top-xs-5 margin-bottom-xs-15 text-color-dark-slate text-size-20 text-weight-bold">
        <FormattedMessage
          id="checkout.parking-type"
          defaultMessage="YOUR PARKING TYPE"
        />
      </h2>
      <div className="row">
        <div className="col-xs-12 text-size-16 text-color-dark-slate text-weight-book margin-bottom-20">
          {quote.tierAmenities.join(' ')}
        </div>
      </div>
      <hr className="visible-xs" />
    </div>
  );
};

TierAmenities.propTypes = propTypes;
TierAmenities.defaultProps = defaultProps;
export default TierAmenities;
